import React, {useMemo, useState} from 'react'
import {RootState} from 'setup'
import {
  applyDiscountCode,
  applyWineClubDiscount,
  selectEditOrder,
  selectEditOrderItems,
  selectIsProductsEditMode,
  selectOrderDiscounts,
  setIsDirtyDiscount,
  setRemovePromoDiscount,
  updateEditOrderWithItems,
  validateDiscountsAndRefetchTax,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Order} from 'app/features/orders/models/EditOrderState'
import {useDispatch, useSelector} from 'react-redux'
import {Discount} from 'app/features/orders/componentsv1/shared/discount'
import EditDiscount from './EditDiscount'
import orderEditService from 'app/services/OrderEditService/OrderEditService'
import {Discount as DiscountType} from 'app/features/orders/models/OrderState'
import PromoRemoveWithPayment from './PromoRemoveWithPayment'

interface DiscountProp {
  discounts: any[]
  show: boolean
}

const initialState: DiscountProp = {discounts: [], show: false}

interface Props {}

export const PromoDiscountAction: React.FC<Props> = () => {
  const dispatch = useDispatch()
  const order = useSelector<RootState, Order>(selectEditOrder)
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)

  const orderItems = useSelector<RootState, any[]>(selectEditOrderItems)
  const discounts = useSelector<RootState, DiscountType>(selectOrderDiscounts)
  const [showDiscount, setShowDiscount] = useState(false)
  const [showDiscountPayment, setShowDiscountPayment] = useState<DiscountProp>(initialState)

  const handleApplyDiscountCode = async (discountCode: string) => {
    await dispatch(updateEditOrderWithItems())
    return await dispatch(applyDiscountCode({orderEditId: order.orderEditId, discountCode}))
  }

  const handleRemoveDiscount = async () => {
    await orderEditService.removeOrderEditDiscount(discounts.promoCodeId)
    const data: any = await dispatch(applyWineClubDiscount(order.orderEditId, orderItems))
    await dispatch(validateDiscountsAndRefetchTax())
    // if (data.discounts && !isProductMode) {
    //   setShowDiscountPayment({discounts: data.discounts, show: true})
    // }
    await dispatch(setRemovePromoDiscount())
  }

  const getDiscountTitle = useMemo(() => {
    if (discounts && discounts.promoCodeId && discounts.code) {
      return {btn: null, name: discounts.code}
    }
    if (order.totalDiscounts > 0) {
      return {btn: null, name: 'Discount'}
    }
    return {btn: 'Add', name: 'Discount'}
  }, [discounts, order.totalDiscounts])

  const handleOpen = () => {
    dispatch(setIsDirtyDiscount(true))
    setShowDiscount(true)
  }

  const handleClose = () => {
    setShowDiscount(false)
  }

  const handleReset = () => {
    setShowDiscountPayment(initialState)
  }

  if (showDiscountPayment && showDiscountPayment?.show) {
    return (
      <PromoRemoveWithPayment onClose={handleReset} discounts={showDiscountPayment.discounts} />
    )
  }

  return (
    <div>
      <Discount
        show={showDiscount}
        onSubmit={handleApplyDiscountCode}
        title={getDiscountTitle}
        discountCodeId={discounts.promoCodeId}
        onRemoveDiscount={handleRemoveDiscount}
        onClick={handleOpen}
      >
        {showDiscount && <EditDiscount onClose={handleClose} />}
      </Discount>
    </div>
  )
}

export default PromoDiscountAction
